export const lst_tipoPrestamo = [
    { id: 1, nombre: "Agro" },
    { id: 2, nombre: "Motos" },
    { id: 3, nombre: "Otros" }]


